import { render, staticRenderFns } from "./ButtonDefinitive.vue?vue&type=template&id=f57b0282&scoped=true&"
import script from "./ButtonDefinitive.vue?vue&type=script&lang=js&"
export * from "./ButtonDefinitive.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDefinitive.vue?vue&type=style&index=0&id=f57b0282&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57b0282",
  null
  
)

export default component.exports